import { createModalStore } from '@/shared/lib/modal';

type DeleteGlossaryModalState = {
  glossaryId: string;
};

const initialState: DeleteGlossaryModalState = {
  glossaryId: '',
};

export const useDeleteGlossaryModalStore = createModalStore(initialState);
